import Vue from 'vue'
import { platformFromQuery, isWebAppQuery } from './web-auth-rules'

const key = 'eelink.web.session'
const initialQuery = {}
const params = new URLSearchParams(window.location.search)
for (const name of ['os', 'webApp']) if (params.has(name)) initialQuery[name] = params.getAll(name).length === 1 ? params.get(name) : params.getAll(name)
function restoredSession() {
  try {
    let saved = null
    try { saved = sessionStorage.getItem(key) } catch (_) { /* Try persistent storage next. */ }
    if (!saved) saved = localStorage.getItem(key)
    const value = JSON.parse(saved)
    return value && typeof value.username === 'string' && [1, 2].includes(value.level) ? value : null
  } catch (_) { return null }
}
export const webAuth = Vue.observable({
  browser: isWebAppQuery(initialQuery), platform: platformFromQuery(initialQuery), session: restoredSession(), expired: false, revision: 0
})

export function saveWebSession(value) {
  webAuth.session = value
  webAuth.expired = false
  webAuth.revision++
  // Metadata is only a recovery hint; the router still verifies the server session.
  const saved = value ? JSON.stringify({ username: value.username, level: value.level, permissions: value.permissions, farmId: value.farmId, profile: value.profile }) : null
  for (const name of ['sessionStorage', 'localStorage']) {
    try {
      if (saved) window[name].setItem(key, saved)
      else window[name].removeItem(key)
    } catch (_) { /* Private browsing may disallow storage; the in-memory session still works. */ }
  }
}

export function expireSession(revision) {
  if (revision !== webAuth.revision || webAuth.expired) return
  if (!webAuth.browser) return
  saveWebSession(null)
  webAuth.expired = true
  window.dispatchEvent(new Event('eelink-web-session-expired'))
}
